// import { useState } from 'react';
// import { Trans, useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Stack } from '@/shared/ui';
// import { Notification } from '@/shared/ui/Notifications/Notification';
import { SvgIcon } from '@/shared/ui/SvgIcon';
import { CustomTypography } from '@/shared/ui/Typography';

import { usePageTitle } from '../model/usePageTitle';

import { StyledIconButton } from './styles';

export const PageTitle = () => {
  // const { t } = useTranslation(['common']);
  const { title, isShowFallback, redirectPath } = usePageTitle();
  const navigate = useNavigate();
  // const [showNotification, setShowNotification] = useState(true);
  const handleBackClick = () => {
    if (redirectPath) {
      navigate(redirectPath);
    } else {
      navigate(-1);
    }
  };

  return (
    <>
      <Stack direction="row" spacing={2} alignItems="center">
        {isShowFallback && (
          <StyledIconButton
            onClick={handleBackClick}
            size="small"
            variant="icon"
          >
            <SvgIcon name="arrow" />
          </StyledIconButton>
        )}
        <CustomTypography variant="h5" component="h1">
          {title}
        </CustomTypography>
      </Stack>

      {/* {showNotification && (
        <Notification
          id="public-beta"
          type="info"
          title={t('common:testingNotification.title')}
          caption={
            <Trans
              i18nKey="common:testingNotification.caption"
              components={{
                bold: <b />,
                br: <br />,
              }}
            />
          }
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          autoHideDuration={null}
          onRemove={() => setShowNotification(false)}
        />
      )} */}
    </>
  );
};
